var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Cards",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Cards",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3h1a2 2 0 012 2v6a2 2 0 01-2 2h-1a2 2 0 01-2 2H5a2 2 0 01-2-2H2a2 2 0 01-2-2V5a2 2 0 012-2h1a2 2 0 012-2h6a2 2 0 012 2zM2 5v6h1V5H2zm3-2v10h6V3H5zm9 2h-1v6h1V5zM9 5H7a1 1 0 000 2h2a1 1 0 000-2zm0 3H7a1 1 0 000 2h2a1 1 0 000-2z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgCarouselIcon;